import React from 'react';
import Button from '../../shared/form/_Button';
import Feature from './Feature';
import { FEATURES } from './constants';
import { browserHistory } from 'react-router';
import Trial from '../../shared/Trial';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

class Features extends React.Component  {
    _handleRedirectToPurchaseForm = () => browserHistory.push('/reps/purchase-subscription');

    render() {
      const { isPremium } = this.props;

      return (
        <div className={ 'premium-features' }>
          <Trial regularComponent={ <React.Fragment>{!isPremium &&
            <React.Fragment>
              <div className={ 'premium-features__header' }>
                        Purchase subscription and <span className={ 'premium-features__header--indicate' }>unlock premium</span> functions
              </div>
              <div className={ 'premium-features__purchase' }>
                {/* <div className={ 'premium-features__price' }>$25 per month</div>*/}
                <Button className='form__button form__button--green premium-features__button' onClick={ this._handleRedirectToPurchaseForm }>
                            Purchase
                </Button>
              </div>
            </React.Fragment>} </React.Fragment> } trialComponent={ <React.Fragment>
            <div className={ 'premium-features__header' }>
                Now you can try the premium account options without additional fees.
              </div>
            <div className={ 'premium-features__purchase' }>
                <Button className='form__button form__button--green premium-features__button' onClick={ this._handleRedirectToPurchaseForm }>
                  Start your trial
              </Button>
            </div>
          </React.Fragment> } />

          <div className={ 'premium-features__row' }>
            {FEATURES.map((feature, index) => (
              <Feature customIconStyle={ feature.customIconStyle } customTitleStyle={ feature.customTitleStyle } header={ feature.header } key={ index }
                list={ feature.list } media={ feature.media } />
            ))}
          </div>
        </div>
      );
    }
}

Features.propTypes = {
  isPremium: PropTypes.bool.isRequired,
  router: PropTypes.shape({
    push: PropTypes.func.isRequired
  })
};

const mapStateToProps = (state) => {
  return {
    isPremium: state.getIn(['currentUser', 'data', 'premium'])
  };
};

export default connect(mapStateToProps)(Features);



// WEBPACK FOOTER //
// ./app/components/reps/premium/Features.jsx